import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { environment } from "src/environments/environment";
import { ValidArray } from "../shared/services/utilities.service";
import { OfflineServiceResponse } from "./offline-service-response.interface";
import { delay } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class OfflineModeInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!environment.local) {
      return next.handle(req);
    }

    const url = new URL(req.url);
    const offlineResponses = new ValidArray(environment.offlineResponses);

    if (offlineResponses.hasValues()) {
      const possibleValues: Array<OfflineServiceResponse> = (environment.offlineResponses! as Array<OfflineServiceResponse>).filter(value => url.pathname === value.path);
      let offlineResponse: OfflineServiceResponse;

      if (possibleValues.length > 1) {
        offlineResponse = possibleValues!.find(value => req.url.includes(value.querystring!))!;
      } else {
        offlineResponse = possibleValues[0];
      }

      if (offlineResponse) {
        return of(new HttpResponse({ body: offlineResponse.response})).pipe(delay(1000));
      }
    }

    return next.handle(req);
  }
}
